<template>
  <section class="section">
    <div class="section__content" v-reveal>
      <div>
        <SectionHeader
          v-if="content.header"
          class="--centered"
          :text="content.header"
          v-reveal="{ delay: 200 }"
        />
        <h2 class="title --centered" v-reveal="{ delay: 250 }">{{ content.title }}</h2>
        <div class="video --centered" v-reveal="{ delay: 250 }">
          <Transition name="fade" mode="out-in">
            <div v-if="video" key="iframe" class="video__frame">
              <iframe
                class="video__iframe"
                :src="embedLink"
                allow="autoplay; encrypted-media"
                allowfullscreen="allowfullscreen"
              />
            </div>
            <div v-else key="placeholder" @click="video = true" class="video__placeholder">
              <img :src="thumbnail" />
              <Icon id="play" />
            </div>
          </Transition>
        </div>
        <CTABlock :content="content.cta[0]" v-if="content.cta.length" class="--centered" />
      </div>
    </div>
  </section>
</template>

<script>
import { CTABlock } from '@/components/blocks'
import { Icon } from '@/components/global'
import { SectionHeader } from '@/components/small'
import { DefaultSectionProps } from '@/mixins'

export default {
  name: 'SectionVideo',
  mixins: [DefaultSectionProps],
  components: { CTABlock, SectionHeader },
  data() {
    return {
      video: false,
    }
  },
  computed: {
    videoId() {
      if (!this.content?.youtube_url) return null

      const url = new URL(this.content.youtube_url)
      let id = url.searchParams.get('v')

      if (!id) {
        id = url.pathname.split('/').at(-1)
      }

      return id
    },

    embedLink() {
      if (!this.content?.youtube_url) return null

      return `https://www.youtube.com/embed/${this.videoId}?autoplay=1&cc_load_policy=1&controls=1&rel=0&enablejsapi=1`
    },

    thumbnail() {
      if (!this.content?.youtube_url) return null

      return `https://img.youtube.com/vi/${this.videoId}/maxresdefault.jpg`
    },
  },
}
</script>
